<div class="video-card" (click)="openVideoModal()">
  <div class="image-container">
    <div class="image-wrapper">
      <img
        #videoImage
        class="video-card-image"
        [src]="
          isMobile
            ? video?.imagemMobile?.href || 'assets/images/placeholder.png'
            : video?.imagem?.href || 'assets/images/placeholder.png'
        "
        alt="Thumbnail do vídeo"
        style="width: 100%"
        (load)="onImageLoad(videoImage)"
      />
    </div>
    <img
      class="video-card-player-button"
      src="assets/icons/video-player-button.svg"
      alt="Play"
    />
    <div class="live-badge" *ngIf="video?.statusTransmissaoValue === 'ao_vivo'">
      <span class="live-dot"></span>
      <span>AO VIVO</span>
    </div>
    <div class="soon-badge" *ngIf="formatDateLabel(video).type === 'soon'">
      <i class="bi bi-broadcast"></i>
      <span>EM BREVE</span>
    </div>
  </div>
  <div
    class="date-container"
    [ngStyle]="{ opacity: formatDateLabel(video).type !== 'empty' ? 1 : 0 }"
    [ngClass]="{ 'dark-theme': bgTheme === 'dark' }"
  >
    <ng-container *ngIf="bgTheme === 'dark'">
      <i class="bi bi-calendar2-event-fill date-icon"></i>
    </ng-container>
    <ng-container *ngIf="bgTheme !== 'dark'">
      <img
        src="assets/icons/date-icon.svg"
        alt="Ícone de data"
        class="date-icon"
      />
    </ng-container>
    <p class="video-date">{{ formatDateLabel(video).label }}</p>
  </div>
  <h3 class="video-title" [ngClass]="{ 'dark-theme': bgTheme === 'dark' }">
    {{ video.title }}
  </h3>
</div>
